import * as React from 'react';

export interface IFavoriteButtonContext {
  isFullscreenGallery?: boolean;
  popupPivotX?: 'right' | 'left';
  customClass?: string;
}

const DEFAULT: IFavoriteButtonContext = {
  isFullscreenGallery: false,
  popupPivotX: undefined,
  customClass: undefined,
};

export const FavoritesButtonContext = React.createContext(DEFAULT);
